module.exports = __webpack_public_path__ + "static/media/atlasBHRILogoMono.d139e4fd.svg";